import { isEmpty } from './appLibrary';

export function getCookieValue(name) {
    if (typeof document === 'undefined' || isEmpty(document.cookie)) return '';

    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
        const prefix = name + '=';
        if (cookie.indexOf(prefix) === 0) {
            return decodeURIComponent(cookie.substring(prefix.length));
        }
    }

    return '';
}

export function getCsrfHeader() {
    const token = getCookieValue('XSRF-TOKEN');
    if (isEmpty(token)) return {};
    return { 'X-CSRF-TOKEN': token };
}

export function getAxiosAuthConfig(config) {
    const baseConfig = config || {};
    return Object.assign({}, baseConfig, {
        withCredentials: true,
        headers: Object.assign({}, baseConfig.headers || {}, getCsrfHeader())
    });
}

export function hasValidLoginSession(user) {
    return !isEmpty(user) && !isEmpty(user.corpkey) && !isEmpty(user.account);
}

export function isUnauthorizedResponse(error) {
    const status = error && error.response && error.response.status;
    return status === 401 || status === 403;
}

export function getResponseErrorDescription(error) {
    const data = error && error.response && error.response.data;
    if (isEmpty(data) || typeof data !== 'object') return '';
    if (!isEmpty(data.errDescription)) return data.errDescription;
    return '';
}
